import { generateAbstract } from '@application/ai-prompts/generate-abstract/command'

import AiGenerator from '@ui/shared/components/AiGenerator'

const tableFeatures = [
  {
    feature: `✂️${'\u00A0'} Copy & paste`,
    description: 'Copy the body of your paper to generate an abstract fast.',
  },
  { feature: `🙌${'\u00A0'} Free to use`, description: 'No payment required, completely free!' },
  {
    feature: `🔒${'\u00A0'} Safe & secure`,
    description: 'Your data is fully encrypted and never stored.',
  },
  {
    feature: `👨‍💻${'\u00A0'} API access`,
    description: 'API access to the Abstract Generator on request.',
  },
]

const faqs = [
  {
    question: 'How do I use the Abstract Generator?',
    answer:
      "To get an auto-generated abstract, paste in the body of your paper (so from your Introduction to Conclusion, but without your abstract and references), and click 'Generate Abstract'. Don't like the generated abstract? Click the Generate button again to get another!",
  },
  {
    question: 'How does the Abstract Generator come up with abstracts?',
    answer:
      "We trained the Abstract Generator model on a data set of title-abstract pairs, derived from published papers. Through this training process, the model learned what elements from a paper are usually presented in the abstract, and how they are structured. It follows these norms to automatically write an abstract from your paper's content.  ",
  },
  {
    question: 'Is the Abstract Generator free to use?',
    answer:
      "Yes, you can use it for free, with a daily quota that we set to avoid abuse. It's also available within Writefull's plugins, like Writefull for Overleaf.",
  },
  {
    question: 'Do you have an API of the Abstract Generator?',
    answer:
      'Yes, you can also use our API to automatically generate abstracts. Contact us at enterprise@writefull.com for more information.',
  },
  {
    question: 'What happens to the texts that I enter into the Abstract Generator? ',
    answer:
      "Nothing at all - we don't store anything. Your text is encrypted and sent to Writefull's servers where it is processed and removed straight after.",
  },
  {
    question: 'Why did you develop the Abstract Generator?',
    answer:
      "The abstract is a challenging paper section to write; you need to summarize your entire paper in one concise paragraph. Simply put, we developed this widget to save you time and frustration. As the Abstract Generator's output is fully AI-based, you'll want to revise it, but you won't need to start from a blank page! ",
  },
]

export default function AbstractGenerator() {
  const handleGenerateAbstract = async (input: string) => {
    const abstract = await generateAbstract(input)
    if (!abstract) {
      return undefined
    }
    return [abstract]
  }
  return (
    <AiGenerator
      label='Paste your paper from your Introduction up to and including your Conclusion'
      actions={[
        {
          name: 'Generate Abstract',
          code: 'generate-abstract',
        },
      ]}
      skeleton={{ type: 'text', bars: 4 }}
      faqs={{ faqs, tableFeatures, widgetName: 'Abstract Generator' }}
      onGenerate={handleGenerateAbstract}
    />
  )
}
